// @flow
import React from 'react';
import injectSheet from 'react-jss';
import cx from 'classnames';
import { S, labelStyle } from './shell/shellTokens';

type Props = {
  title: string,
  children: Object,
  classes: Object,
  isOpen: Boolean,
  onClick: () => void
}

function Section({ title, children, classes: c, isOpen, onClick }: Props) {
  return (
    <div className={cx(c.section, { 'is-open': isOpen })}>
      <button
        type="button"
        className={c.sectionTitle}
        aria-expanded={!!isOpen}
        onClick={() => onClick()}
      >
        <span>{title}</span>
        <i className="material-icons" aria-hidden>{isOpen ? 'expand_less' : 'expand_more'}</i>
      </button>
      {children}
    </div>
  );
}

const styles = {
  section: {
    borderTop: `1px solid ${S.line}`
  },
  sectionTitle: {
    all: 'unset',
    boxSizing: 'border-box',
    cursor: 'pointer',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 0',
    ...labelStyle,
    '& .material-icons': { fontSize: 18 },
    '&:hover, &:focus-visible': { color: S.fg }
  }
};

export default injectSheet(styles)(Section);
